module.exports = __webpack_public_path__ + "img/96.cba84235.jpg";